<!--
  使用率兑付率弹窗
-->
<template>
  <div class="map-info-window">
    <div class="window-header">
      <div class="header-left">
        {{infoObj.areaName + '农机报废企业 - ' + infoObj.detail.length  + '家'}}
      </div>
      <div class="header-right" @click="close"></div>
    </div>
    <div class="window-body">
      <div class="enterprise-info" v-for="(item, index) in infoObj.detail" :key="index">
        <div class="enterprise-name">
          <img src="../../../../assets/images/governmentAffairs/scrapSubsidy/map/bg_business_name.png"></img>
          <p>{{item.recyclingCompanyName}}</p>
        </div>
        <div class="info-detail-item">
          <div class="label">统一社会信用代码： </div>
          <div class="value">{{item.socialCreditCode}}</div>
        </div>
        <div class="info-detail-item">
          <div class="label">法人： </div>
          <div class="value">{{item.legalRepresentativeName}}</div>
        </div>
        <div class="info-detail-item">
          <div class="label">经营场所： </div>
          <div class="value">{{item.businessLocation}}</div>
        </div>
        <div class="info-detail-item">
          <div class="label">回收标准：</div>
          <div class="value">{{item.recyclingStandards}}</div>
        </div>
        <div class="line" v-if="index != infoObj.arr - 1"></div>
      </div>
    </div>
    <div class="window-footer"></div>
  </div>
</template>
<script>
export default {
  name: 'map-info-window',
  props: {
    infoObj: {
      type: Object,
      default: () => {}
    },
    vmm: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
  
    }
  },
  methods: {
    close() {
      this.vmm.closeWindow();
    }
  }
}
</script>
<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 1920) * 100vw;
}
@function vh($px) {
  @return ($px / 1080) * 100vh;
}
@function fontSize($px) {
  @return 100vw * $px / 1920;
}

.map-info-window {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 377px;
  font-family: Microsoft YaHei;
  position: relative;
  z-index: 100;
  .window-header {
    position: relative;
    width: 379px;
    height: 49px;
    background: url("../../../../assets/images/governmentAffairs/scrapSubsidy/map/bg_tk_bf_con_u.png") no-repeat;
    background-size: 100%;
    .header-left {
      position: absolute;
      top: 66%; 
      left: 30px; 
      transform: translate(0, -50%); /* 调整位置 */
      font-weight: bold;
      font-size: 18px;
      color: #FFFFFF;
      text-shadow: 1px 2px 0px #00552C;
      font-style: italic;
      padding-right: 10px;
    }
    .header-right {
      position: absolute;
      right: 26px;
      top: 66%; 
      transform: translate(0, -50%); /* 调整位置 */
      width: 13px;
      height: 12px;
      background: url("../../../../assets/images/governmentAffairs/scrapSubsidy/map/icon_bf_close.png") no-repeat;
      background-size: 100%;
    }
  }
  .window-body {
    flex: 1;
    width: 96%;
    margin-left: -4%;
    max-height: 470px;
    overflow-y: auto;
    background: url("../../../../assets/images/governmentAffairs/scrapSubsidy/map/bg_tk_bf_con_c.png");
    .enterprise-info {
      padding-top: 4px;
      .enterprise-name {
        position: relative;
        height: 30px; 
        font-size: 16px;
        color: #FFFFFF;
        font-style: italic;
        img {
          position: absolute;
          top: 0;
          left: 26px;
          width: 169px;
          height: 31px; 
        }
        p {
          font-weight: bold;
          position: absolute;
          top: 5px;
          left: 24px;
          margin-left: 20px;
          line-height: 20px;
          padding-right: 12px;
          background: linear-gradient(0deg, #FFFFFF 0%, #BAFFD2 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }
        
      }
      .info-detail-item {
        margin-left: 30px;
        margin-bottom: 2px;
        display: flex;
        align-items: flex-start;
        font-size: 14px;
        .label {
          width: 130px;
          color: #3DB868;
          text-align: right;
        }
        .value {
          max-width: 190px;
          color: #C7FFDB;
        }
      }
      .line {
        margin: 14px 30px 0 30px;
        width: 312px;
        height: 1px;
        background-color: #6CBA87;
        opacity: 0.8;
      }
    }
  }
  .window-footer {
    width: 377px;
    height: 18px;
    background: url("../../../../assets/images/governmentAffairs/scrapSubsidy/map/bg_tk_bf_con_b.png") no-repeat;
    background-size: 100%;
  }
  .window-body::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 1px;
  }
  .window-body::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 2px;
    background-color: #00B33E;;
    background-image: -webkit-linear-gradient(
      45deg,
      rgba(255, 255, 255, 0.2) 25%,
      transparent 25%,
      transparent 50%,
      rgba(255, 255, 255, 0.2) 50%,
      rgba(255, 255, 255, 0.2) 75%,
      transparent 75%,
      transparent
    );
  }
  .window-body::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: #023f30;
    border-radius: 2px;
  }
}
 
</style>
